// -----------------------------------------------------------------------------
// Scripts for parallax effect
// -----------------------------------------------------------------------------

$(document).ready(function () {});